import React from 'react';
import { UserPlus, UserCheck } from 'lucide-react';
import Tooltip from '../common/Tooltip';

interface FollowButtonProps {
  userId: number;
  isFollowing: boolean;
  onToggle: (userId: number) => void;
  loading?: boolean;
}

const FollowButton: React.FC<FollowButtonProps> = ({
  userId,
  isFollowing,
  onToggle,
  loading = false,
}) => {
  const handleClick = () => {
    if (!loading) {
      onToggle(userId);
    }
  };

  return (
    <Tooltip content={isFollowing ? 'Unfollow this user' : 'Follow to see their projects in your feed'}>
    <button
      onClick={handleClick}
      disabled={loading}
      aria-busy={loading}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
        isFollowing
          ? 'bg-gray-100 text-gray-700 hover:bg-red-50 hover:text-red-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-red-900/30 dark:hover:text-red-400'
          : 'bg-primary-600 text-white hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600'
      } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {isFollowing ? (
        <>
          <UserCheck className="w-4 h-4" aria-hidden="true" />
          Following
        </>
      ) : (
        <>
          <UserPlus className="w-4 h-4" aria-hidden="true" />
          Follow
        </>
      )}
    </button>
    </Tooltip>
  );
};

export default FollowButton;
